import React from 'react';
import PropTypes from 'prop-types';

export default function CategoryIconWithTitle({ item, count }) {
  return (
    <>
      <i className={item.icon} />
      <div className="text-content">
        {item.name}
        {count !== null && (
        <span className="ps-1">
          (
          {count}
          )
        </span>
        )}
      </div>
    </>
  );
}

CategoryIconWithTitle.propTypes = {
  item: PropTypes.object.isRequired,
  count: PropTypes.number,
};

CategoryIconWithTitle.defaultProps = {
  count: null,
};
